<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const server = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptMcpServers/getUIFlags'];

const description = computed(() =>
  t('WGPT_MCP_SERVERS.DELETE.CONFIRM.MESSAGE', { name: server.value.name })
);

const handleDialogConfirm = async () => {
  const id = server.value.id;
  if (!id) return;

  try {
    await store.dispatch('wgptMcpServers/delete', id);
    useAlert(t('WGPT_MCP_SERVERS.DELETE.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('WGPT_MCP_SERVERS.DELETE.API.ERROR_MESSAGE'));
  } finally {
    dialogRef.value?.close();
  }
};

const open = selectedServer => {
  server.value = selectedServer;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_MCP_SERVERS.DELETE.TITLE')"
    :description="description"
    :confirm-button-label="t('WGPT_MCP_SERVERS.DELETE.CONFIRM.YES')"
    :cancel-button-label="t('WGPT_MCP_SERVERS.DELETE.CONFIRM.NO')"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
